import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="wrapper--narrow">
      <div className="text__standard text-left">
        <h2
          className="h2 standard__heading heading-size-7 aos-init aos-animate"
          data-aos="hero"
          data-aos-anchor="[data-section-id='template--25944470782316__main']"
          data-aos-order={2}
        >
          Privacy
        </h2>
        <div
          data-aos="hero"
          data-aos-anchor="[data-section-id='template--25944470782316__main']"
          data-aos-order={3}
          className="aos-init aos-animate"
        >
          <div className="rte body-size-5">
            <meta charSet="utf-8" />
            <meta charSet="utf-8" />
            <p>
              <strong>PRIVACY POLICY</strong>
            </p>
            <p>Last updated September 8, 2026</p>
            <p>
              Welcome to&nbsp;the&nbsp;Sacuddin Website,&nbsp;
              <Link onClick={toTop} to="/">
                sacuddin.shop
              </Link>
              &nbsp;(the “Website” or “Services”). The Services are operated by
              Sacuddin, Inc. (“we,” “us,” or “our”). We believe that the privacy
              and security of your information and personal data (“Information”)
              is very important. This Privacy Policy (“Policy”) explains the
              type of Information we collect from users of the Services, how
              that Information is used, how the Information may be shared with
              other parties, and what controls our users have regarding their
              Information. We encourage you to read this Policy carefully.
            </p>
            <p>
              Any updates or modifications to this Policy will be posted to our
              Website on this page. By using or accessing the Services, you
              signify that you have read, understand and agree to be bound by
              this Policy.
            </p>
            <p>
              Our Services are operated in the United States but can be accessed
              worldwide.
            </p>
            <p>
              If you are located in the European Economic Area (“EEA”),
              Switzerland, or the United Kingdom, we are subject to the UK
              General Data Protection Regulation (“UK GDPR”) and the EU General
              Data Protection Regulation (“EU GDPR”) and are the Controller of
              your data.
            </p>
            <p>
              California residents should consult the section titled “ Your
              California Privacy Rights” for rights that apply to them.
            </p>
            <p>
              If you have questions about this Policy, please contact us
              at&nbsp;
              <Link onClick={toTop} to="mailto:kit@sacuddin.shop">
                kit@sacuddin.shop
              </Link>
            </p>
            <p>
              <strong>INFORMATION WE COLLECT AND HOW WE USE IT</strong>
            </p>
            <p>
              <em>Types of Information</em>
            </p>
            <p>
              We may collect the following types of Information through our
              Services:
            </p>
            <p>
              (1) “Personal Data” such as your name, e-mail address and phone
              number, mailing address, and other information that can be used to
              directly identify and contact you (which, in some cases, may
              include certain Device Information or information from the
              signature block of your e-mail);
            </p>
            <p>
              (2) “Device Information” which is information relating to the
              computer or device you are using when you access our Services,
              such as your computer’s IP address, your mobile device identifiers
              (including Apple IDFA or an Android Advertising ID), the type of
              browser and operating system you are using, the identity of your
              internet service provider, and your device and browser settings.
            </p>
            <p>
              (3) “Usage Data” which is data related to your use of the Services
              such as the pages you visit, the sites you use before or after
              visiting ours, your actions within the Services, the type of
              content or advertisements you have accessed, seen, forwarded
              and/or clicked on, Wi-Fi connections, date and time stamps, log
              files, and diagnostic, crash, website, and performance logs and
              reports.
            </p>
            <p>
              As described in more detail below, we collect Personal Data only
              when you provide it to us but may collect other types of
              Information whenever you use our Services through automated means
              such as software developer kits, cookies and web beacons (which
              are discussed in more detail below).
            </p>
            <p>
              <em>Personal Data</em>
            </p>
            <p>
              You may enter the Website and browse its content without
              submitting any Personal Data. However, we will need to collect
              relevant Personal Data to provide you with certain services
              offered by the Services, including if you choose to create an
              account on our website, contact us or otherwise communicate with
              us in any way, subscribe or opt in to our newsletter, alerts, or
              other communications, subscribe or opt in to SMS messages, sign up
              for product waitlists, participate in a contest or promotion,
              order our products, submit product reviews, questions, feedback or
              user comments, complete an optional survey, contact customer
              service or otherwise interact with the Services.
            </p>
            <p>
              We use the Personal Data that we collect to respond to your
              requests, communicate with you regarding the Services and our
              content, send you promotional or marketing communications, guard
              against potential fraud, provide product information, service your
              requests and orders, and provide you with the applicable services,
              features or functionality associated with your submission. When
              you submit Personal Data through the Services, whether by directly
              providing it to us upon request or voluntarily disclosing it
              through comments, you are giving your consent to the collection,
              use and disclosure of your Personal Data as set forth in this
              Privacy Policy.
            </p>
            <p>
              <em>Device Information &amp; Usage Data</em>
            </p>
            <p>
              Whether or not you submit Personal Data, any time you visit our
              Services, we or our service providers may collect, store or
              accumulate certain Device Information and Usage Data. This
              Information may be used in furtherance of the purposes described
              above with respect to Personal Data and in aggregate form for
              internal business purposes, such as optimizing the Services,
              evaluating the popularity of content, generating statistics and
              developing marketing plans, and otherwise for general
              administrative, analytical, research, optimization, and security
              purposes.
            </p>
            <p>
              <em>Information to and from Social Networks</em>
            </p>
            <p>
              We may provide functionality that will allow you to connect to our
              Services through a third-party social network. If you connect
              through a Social Network, we may collect Personal Data from your
              profile, such as your name, username, and e-mail address, and we
              will use that Personal Data for the purposes set forth herein. In
              addition, our Services may offer social sharing features which
              will allow you to “Share” or “Like” on a Social Network. If you
              decide to use such features, it may allow the sharing and
              collection of Information both to and from such Social Network, so
              you should check the privacy policy of each Social Network before
              using such features.
            </p>
            <p>
              <strong>SHARING OF INFORMATION</strong>
            </p>
            <p>
              In no event will we disclose, rent, sell or share any of your
              Personal Data to third parties for direct marketing purposes. We
              only share your Information with third parties for the purposes
              described below.
            </p>
            <p>
              We contract with companies or individuals to provide certain
              services related to the functionality and features of the
              Services, including content streaming, email and hosting services,
              software development, data management, orders, payment processing,
              management of forms, quizzes and polls, customer service, returns,
              live chat, marketing, fraud prevention, product review and
              questions, and administration of contests and other promotions. We
              call them our “Service Providers.” We may share your Information
              with Service Providers as appropriate for them to perform their
              services for us and our Service Providers are permitted to use
              your Information only for such purposes.
            </p>
            <p>
              We use Shopify, Inc. to host our website and to process our
              orders. Shopify’s privacy policy is located at:
            </p>
            <p>
              <Link onClick={toTop} to="/privacy">
                Privacy
              </Link>
            </p>
            <p>
              The server automatically logs the IP address you use to access our
              website as well as other information about your visit such as the
              pages accessed, information requested, the date and time of the
              request, the source of your access to our website (e.g. the
              website or URL (link) which referred you to our website), and your
              browser version and operating system.
            </p>
            <p>
              In certain instances, as with Paypal, which process payments, you
              may also be directed to a third-party website which is governed by
              its own privacy policy:
            </p>
            <p>
              <Link onClick={toTop} to="/">
                Home
              </Link>
            </p>
            <p>
              We may also share or transfer Device Information and Usage Data in
              aggregated, anonymized form with or to our affiliates, licensees,
              partners and Service Providers for administrative, analytical,
              research, optimization, and security purposes, but no such
              Information will be linked with your Personal Data or be used to
              identify or contact you.
            </p>
            <p>
              Finally, we may share your Information: (i) In response to
              subpoenas, court orders, or other legal process; to establish or
              exercise our legal rights; to defend against legal claims; or as
              otherwise required by law. In such cases we reserve the right to
              raise or waive any legal objection or right available to us; (ii)
              When we believe it is appropriate to investigate, prevent, or take
              action regarding illegal or suspected illegal activities; to
              protect and defend the rights, property, or safety of our company,
              our users, or others; and in connection with the enforcement of
              our Terms of Use and other agreements; or (iii) In connection with
              a corporate transaction, such as a divestiture, merger,
              consolidation, or asset sale, or in the unlikely event of
              bankruptcy.
            </p>
            <p>
              <strong>AUTOMATED DATA COLLECTION / COOKIES</strong>
            </p>
            <p>
              We may use certain automatic analytics and tracking technologies
              to assist us in performing a variety of functions, including
              storing your Information, collecting Device Information and Usage
              Data, understanding your use of the Services and customizing the
              content offered to you on the Services. We may use platforms like
              Google Analytics to provide aggregated or anonymized information
              relating to demographics, geography, interests or affinities.
              Other technologies we may use include:
            </p>
            <p>
              <span style={{ textDecoration: "underline" }}>(1) Cookies.</span>{" "}
              Cookies are text files placed in your computer's browser to store
              your preferences. We use cookies or other tracking technologies to
              understand site and Internet usage and to improve or customize the
              Services and the content, offerings, or advertisements you see on
              the Services. For example, we may use cookies to personalize your
              experience on the Services or remember any settings you have
              chosen. Most web browsers automatically accept cookies, but you
              can usually configure your browser to prevent this. However, not
              accepting cookies may make certain features of the Services
              unavailable to you.
            </p>
            <p>
              <span style={{ textDecoration: "underline" }}>
                (2) Web Beacons.
              </span>{" "}
              We may also use "web beacons" or clear GIFs, or similar
              technologies, which are small pieces of code placed on a web page
              or in an email, to monitor the behavior and collect data about the
              visitors viewing a web page or email. For example, web beacons may
              be used to count the users who visit a web page or to deliver a
              cookie to the browser of a visitor viewing that page. Web beacons
              may also be used to provide information on the effectiveness of
              our email campaigns (e.g., open rates, clicks, forwards, etc.).
            </p>
            <p>
              <span style={{ textDecoration: "underline" }}>
                (3) Mobile Device Identifiers and SDKs.
              </span>{" "}
              We also sometimes use, or partner with publishers or app developer
              platforms that use, mobile Software Development Kits ("SDKs") that
              are incorporated into the Services to collect Information, such as
              mobile identifiers (e.g., IDFAs and Android Advertising IDs),
              geolocation information, and other information about your device
              or use of the Services. A mobile SDK may act as the mobile version
              of a web beacon (see "Web Beacons" above).
            </p>
            <p>
              By visiting the Services, whether as a registered user or
              otherwise, you acknowledge, and agree that you are giving us your
              consent to track your activities and your use of the Services
              through the technologies described above, as well as similar
              technologies developed in the future, and that we may use such
              tracking technologies in the emails we send to you. Please note
              that no such tracking technologies will collect any Personal Data
              from you unless you choose to submit it to us and that data
              relating to you individually is not shared with any third parties.
            </p>
            <p>
              <strong>PERSONAL DATA RETENTION</strong>
            </p>
            <p>
              We retain the Personal Data we receive as described in this
              Privacy Policy for as long as you use the Services or as necessary
              to fulfill the purpose(s) for which it was collected, resolve
              disputes, establish legal defenses, conduct audits, pursue
              legitimate business purposes, enforce our agreements, and comply
              with applicable laws.
            </p>
            <p>
              <strong>PRIVACY AND SECURITY</strong>
            </p>
            <p>
              We take reasonable precautions to protect our customers' Personal
              Data against loss, misuse, unauthorized disclosure, alteration,
              and destruction. However, please remember that no transmission of
              data over the Internet or any wireless network can be guaranteed
              to be 100% secure. As a result, while we strive to protect your
              Personal Data, we cannot ensure or warrant the security of any
              Information that you transmit to us or from us, and you do so at
              your own risk. You hereby acknowledge that we are not responsible
              for any intercepted information sent via the Internet, and you
              hereby release us from any and all claims arising out of or
              related to the use of intercepted information in any unauthorized
              manner.
            </p>
            <p>
              If you believe your Personal Data is being improperly used by us
              or any third party, please immediately notify us via email at{" "}
              <Link onClick={toTop} to="mailto:kit@sacuddin.shop">
                kit@sacuddin.shop
              </Link>
            </p>
            <p>
              <strong>USE OF AUTOMATED DECISION MAKING AND PROFILING</strong>
            </p>
            <p>
              Except to the extent personal data is used by third-party ad
              networks for online behavioral advertising, neither we, nor
              service providers on our behalf, engage in profiling or automated
              decision-making activities that produce legal and/or similarly
              significant effects upon you.
            </p>
            <p>
              <strong>CHILDREN UNDER&nbsp;16</strong>
            </p>
            <p>
              Children under 16 years of age are not permitted to use the
              Services. We do not knowingly collect or solicit Personal Data
              directly from anyone under the age of 16. If you are under 13,
              please do not send any Personal Data about yourself to us,
              including your name, address, telephone number, or email address.
              In the event that we learn that we have collected Personal Data
              from a child under age 13, we will delete that information as
              quickly as possible. If you are a parent or guardian of a child
              under 13 years of age and you believe your child has provided us
              with Personal Data, please contact us at&nbsp;
              <Link onClick={toTop} to="mailto:kit@sacuddin.shop">
                kit@sacuddin.shop
              </Link>
            </p>
            <p>
              <strong>LINKS TO THIRD PARTY PLATFORMS</strong>
            </p>
            <p>
              Our Services or communications may contain links to third party
              websites, over which we exercise no control, including the form of
              embedded content, sponsored content or co-branded content. Except
              as set forth in this Policy, we do not share your Personal Data
              with those third parties and are not responsible for the privacy
              policies of any third party or their management of your Personal
              Data. Because they may treat your Information differently than we
              do, we suggest you read the privacy policies on those third-party
              websites prior to submitting any Personal Data to such sites.
            </p>
            <p>
              In addition, you may be redirected to a third-party platform for
              certain functions, including returns, forms, and customer service.
              See above section regarding “Sharing of Information.”
            </p>
            <p>
              <strong>YOUR RIGHTS</strong>
            </p>
            <p>Opting Out of Communications</p>
            <p>
              As described above, we may use the Personal Data we collect from
              you to send you newsletters or other communications from us,
              including those promotional or marketing in nature. If you do not
              want to receive such communications, you can opt out.
            </p>
            <p>
              You may also at any time opt out of receiving communications from
              us by sending an e-mail to&nbsp;
              <Link onClick={toTop} to="mailto:kit@sacuddin.shop">
                kit@sacuddin.shop
              </Link>
              &nbsp;with the subject line “Opt Out.”
            </p>
            <p>Disallowing Cookies and Location Data Collection</p>
            <p>
              You can opt out of the collection and use of certain information,
              which we collect about you by automated means, by changing the
              settings in the device you use to access the Services. In
              addition, your browser may tell you how to be notified and opt out
              of receiving certain types of cookies. Please note, however, that
              without cookies you may not be able to use some or all of the
              features of the Services.
              <br />
              The online advertising industry also provides websites from which
              you may opt out of receiving targeted ads from data partners and
              other advertising partners that participate in self-regulatory
              programs. You can access these and learn more about targeted
              advertising and consumer choice and privacy, at:
            </p>
            <p>
              <Link onClick={toTop} to="/">
                Home
              </Link>
            </p>
            <p>Your Right to Access, Review, and Delete Personal Data</p>
            <p>
              Under certain laws, including the General Data Protection
              Regulation (“GDPR”) and the California Consumer Privacy Act
              (“CCPA”), you may have the right to: obtain confirmation that we
              hold Personal Data about you, request access to and receive
              information about the Personal Data we maintain about you,
              restrict the use of the data, receive the data in a portable
              format, receive copies of the Personal Data we maintain about you,
              update and correct inaccuracies in your Personal Data, object to
              the continued processing or use of your Personal Data, complain to
              a supervisory authority, and have the Personal Data blocked,
              anonymized or deleted, as appropriate. The right to access
              Personal Data may be limited in some circumstances by local law.
              If you qualify, in order to exercise these rights, please contact
              us as set forth below.
            </p>
            <p>
              Sacuddin, Inc
              <br />
              E-mail:{" "}
              <Link onClick={toTop} to="mailto:kit@sacuddin.shop">
                kit@sacuddin.shop
              </Link>
            </p>
            <p>
              We may ask you to provide additional information for identity
              verification purposes, or to verify that you are in possession of
              an applicable email account.
            </p>
            <p>
              Please understand, however, that we reserve the right to retain an
              archive of such Personal Data for a commercially reasonable time
              to ensure that its deletion does not affect the integrity of our
              data; and we further reserve the right to retain an anonymous
              version of such Information.
            </p>
            <p>Do Not Track</p>
            <p>
              We use analytics systems and providers and participate in ad
              networks that process Personal Information about your online
              activities over time and across third-party websites or online
              services, and these systems and providers may provide some of this
              information to us. We process or comply with any web browser’s “do
              not track” signal or similar mechanisms.
              <br />
              Note, however, that you may find information about how to opt out
              of online behavioral advertising and/or block or reject certain
              tracking technologies in the section caption “Disallowing Cookies
              and Location Data Collection” above.
            </p>
            <p>
              <strong>CHANGES TO THIS PRIVACY POLICY</strong>
            </p>
            <p>
              We reserve the right to change this Policy at any time. In the
              event we make changes to this Policy, such policy will be
              re-posted in the "Privacy" section of our Services with the date
              such modifications were made indicated on the top of the page.
              Therefore, please review this Policy from time to time so that you
              are aware when any changes are made to this Policy. If you have
              any questions about the changes that were implemented, please
              contact us at&nbsp;
              <Link onClick={toTop} to="mailto:kit@sacuddin.shop">
                kit@sacuddin.shop
              </Link>
              &nbsp;and include “Information Regarding Updated Policy” in the
              subject line. In any event, your continued use of the Services
              after such change constitutes your acceptance of any such
              change(s), and if you do not accept any changes, you may choose
              not to use the Services or opt out by sending us an appropriate
              notice.&nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
